import AxiosClient from "../../../Network/AxiosClient";

const MERCHANT_LOAN_BASE = `${process.env.REACT_APP_API_URL}/api/merchant-loan/v1`;

export const buildMerchantLoanListUrl = ({
  pageNo,
  pageSize,
  approvedType,
  search,
  geographyFilters,
}) => {
  const params = new URLSearchParams({
    page_no: pageNo,
    page_size: pageSize,
  });

  if (approvedType) params.append("approved_type", approvedType);
  if (search) params.append("search", search);

  if (geographyFilters?.clusters?.length) {
    geographyFilters.clusters.forEach((cluster) =>
      params.append("cluster", cluster)
    );
  }

  if (geographyFilters?.agency?.length) {
    geographyFilters.agency.forEach((agency) =>
      params.append("agency", agency)
    );
  }

  if (geographyFilters?.region?.length) {
    geographyFilters.region.forEach((region) =>
      params.append("region", region)
    );
  }

  if (geographyFilters?.area?.length) {
    geographyFilters.area.forEach((area) => params.append("area", area));
  }

  if (geographyFilters?.territory?.length) {
    geographyFilters.territory.forEach((territory) =>
      params.append("territory", territory)
    );
  }

  return `${MERCHANT_LOAN_BASE}/loans?${params.toString()}`;
};

export const getReviewSubmissionReasonsUrl = ({ userType, reasonType }) =>
  `${MERCHANT_LOAN_BASE}/review-submission?user_type=${userType}&reason_type=${reasonType}`;

export const submitLoanReviewSubmission = ({
  identityId,
  loanRequestId,
  userType,
  reasonType,
  reasons,
}) => {
  const payload = {
    identity_id: identityId,
    loan_request_id: loanRequestId,
    user_type: userType,
  };

  if (reasonType) {
    payload.reason_type = reasonType;
  }

  if (Array.isArray(reasons) && reasons.length > 0) {
    payload.reasons = reasons;
  }

  return AxiosClient.post(`${MERCHANT_LOAN_BASE}/review-submission`, payload);
};

export const getLoanReasonsUrl = () => `${MERCHANT_LOAN_BASE}/loan-reason`;

export const saveLoanReasons = ({ modifications }) =>
  AxiosClient.post(getLoanReasonsUrl(), { modifications });

export const getLoanReviewUrl = ({ walletNumber, identityId, loanRequestId }) =>
  `${MERCHANT_LOAN_BASE}/review/loan?wallet_number=${walletNumber}&identity_id=${identityId}&loan_request_id=${loanRequestId}`;

export const getMerchantInformationUrl = ({ walletNumber }) =>
  `${process.env.REACT_APP_API_URL}/api/outlets/v1/merchant-information?wallet_number=${walletNumber}`;

export const getLastNCallSummaryUrl = ({ walletNumber }) =>
  `${process.env.REACT_APP_API_URL}/api/calls/v1/last-n-call-summary?wallet_number=${walletNumber}`;

export const getLastNBipononCallSummaryUrl = ({ walletNumber }) =>
  `${process.env.REACT_APP_API_URL}/api/calls/v1/last-n-call-summary-biponon?wallet_number=${walletNumber}`;

export const getTransactionSummaryUrl = ({ walletNumber }) =>
  `${process.env.REACT_APP_API_URL}/api/outlets/v1/transaction-summary?wallet_number=${walletNumber}`;
